import { AsYouType, CountryCode, parsePhoneNumberWithError } from "libphonenumber-js"

// Our phone formatting library doesn't handle US phone number well
const formatUSPhoneNumber = (phoneNumber: string) => {
  if (phoneNumber.length <= 6) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`
}

export const getFormattedPhoneNumber = (phoneNumber: string, countryCode: string) => {
  try {
    if (phoneNumber.length <= 3) return phoneNumber

    if (countryCode === "US") return formatUSPhoneNumber(phoneNumber)
    return new AsYouType(countryCode as CountryCode).input(phoneNumber)
  } catch (err) {
    return ""
  }
}

// For displaying phone numbers
export const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return ""
  const parsedPhoneObject = parsePhoneNumberWithError(phoneNumber, "US")
  const parsedPhoneNumber = parsedPhoneObject?.nationalNumber
  const parsedCountryCode = parsedPhoneObject?.country || "US"
  return getFormattedPhoneNumber(parsedPhoneNumber, parsedCountryCode)
}
